export default __webpack_public_path__ + "static/media/contactus.9823df48.png";